import { createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'
import { AdminBalanceTransfersPage } from '@/features/finance/balance-transfers/pages/balance-transfers-page'

export const Route = createFileRoute('/_authenticated/balance-transfers')({
  component: AdminBalanceTransfersPage,
  beforeLoad: requireRole(['admin']),
})
